export default "__VITE_ASSET__CiCgZbXW__"